import { type FC } from 'react'
import { Spinner } from 'react-bootstrap'
import { Modal } from '../../components/Modal/Modal'
import { type InviteState } from '../../store/auth/auth'
import { BulkInvitationModal as BulkInvitationModalLegacy } from './BulkInvitation/BulkInvitationModal'
import { BulkInvitationRevampModal } from './BulkInvitationRevamp/BulkInvitationRevampModal'
import { useInviteFlowRevampEnabled } from './useInviteFlowRevampEnabled'

export interface BulkInvitationModalProps {
  onHide: () => void
  onInvited?: (state: InviteState) => void
}

export const BulkInvitationModal: FC<BulkInvitationModalProps> = ({ onHide, onInvited }) => {
  const { isEnabled, isLoading } = useInviteFlowRevampEnabled()

  if (isLoading) {
    return (
      <Modal
        show
        onHide={onHide}
        size='xl'
        header={<h4 className='d-flex'>Bulk Invitation</h4>}
        body={
          <div className='d-flex align-items-center justify-content-center p-4'>
            <Spinner />
          </div>
        }
        showFooterActions={false}
      />
    )
  }

  return isEnabled ? <BulkInvitationRevampModal onHide={onHide} onInvited={onInvited} /> : <BulkInvitationModalLegacy onHide={onHide} />
}
